/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetAllNonFINRAPaymentMemberDetailLookups: {
        $xmlns: 'http://dobs.pa.gov/sc/lookup/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetAllNonFINRAPaymentMemberDetailLookupsResponse.PaymentTypes.SC_LU_NonFINRAPaymentType',
      'GetAllNonFINRAPaymentMemberDetailLookupsResponse.PaymentRegardings.SC_LU_NonFINRAPaymentRegarding'
    ],
    blueprint: {
      paymentType: [
        '$..SC_LU_NonFINRAPaymentType',
        {
          id: '$..ID',
          type: '$..Type'
        }
      ],
      paymentRegarding: [
        '$..SC_LU_NonFINRAPaymentRegarding',
        {
          id: '$..ID',
          regarding: '$..Regarding'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
